import { render, staticRenderFns } from "./curriculumCourseChoose.vue?vue&type=template&id=5e33f181&scoped=true"
import script from "./curriculumCourseChoose.vue?vue&type=script&lang=js"
export * from "./curriculumCourseChoose.vue?vue&type=script&lang=js"
import style0 from "./curriculumCourseChoose.vue?vue&type=style&index=0&id=5e33f181&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e33f181",
  null
  
)

export default component.exports